import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { OrdersServiceWithApplyToAll } from './orders.service';

@Injectable()
export class ApplyToAllService {
  applyToAll$ = new Subject<{
    orderInfo: { orderId: string; orderItemId: number; selectedConfigIndex: number };
    key: FormlyFieldConfig['key'];
    value: any;
  }>();
  private ordersService = inject(OrdersServiceWithApplyToAll);

  constructor() {
    this.applyToAll$.pipe(takeUntilDestroyed()).subscribe((applyToAllConfigsDto) => {
      this.ordersService.applyValueToAllConfigurationsFromOrder$.next(applyToAllConfigsDto);
    });
  }
}
